import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const iconPath = `M32,14v-6c0-1.1-.9-2-2-2s-2,.9-2,2v6h-8v-6c0-1.1-.9-2-2-2s-2,.9-2,2v6c-2.2,0-4,1.8-4,4v9c0,1.1,.64,
                2.64,1.42,3.42l5.58,5.58v4c0,1.1,.9,2,2,2h6c1.1,0,2-.9,2-2v-4l5.58-5.58c.78-.78,1.42-2.32,
                1.42-3.42v-9c0-2.2-1.8-4-4-4Zm-4,11.5l-4.26,8.72c-.08,.18-.26,.28-.44,.28-.04,0-.08,
                0-.12-.02-.22-.06-.38-.26-.38-.48v-6.78h-2.34c-.18,
                0-.34-.08-.42-.24-.1-.14-.1-.34-.02-.48l4.26-8.72c.1-.2,.34-.32,.56-.26s.38,.26,.38,.48v6.78h2.34c.18,
                0,.34,.08,.42,.24s.1,.32,.02,.48Z`

/**
 * Stateless function representing an Electric Vehicles (EV) charger plug icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <EvChargerPlugIcon width={12} />
 */
const EvChargerPlugIcon = props => (
    <SvgIcon {...props}>
        <path d={iconPath} />
    </SvgIcon>
)

EvChargerPlugIcon.defaultProps = defaultProps

export { EvChargerPlugIcon }
